import { privateAxios } from 'services/api/privateAxios';
import { commonAPI } from 'services/api/apiUrl';

export const logout = () =>
  privateAxios({
    method: 'get',
    baseURL: commonAPI,
    url: '/auth/logout',
  });
